import React, { Component } from 'react';
import { Card, Row, Col, Input, Button, Skeleton, Modal, Spin, Table, Radio, Popover } from 'antd';

import { distanceInWordsToNow } from 'date-fns';
import { isFunction, pick } from 'lodash';
import { inject, observer } from 'mobx-react';

import { api } from '../../../../../services';

import './NoteCard.css';
import moment from 'moment';

const { TextArea } = Input;

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

@inject('translationsStore', 'commonStore')
@observer
export default class NoteCard extends Component {
  constructor(props) {
    super(props);

    const { commonStore } = this.props;
    this.historyTableColumns = [
      {
        dataIndex: 'createdAt',
        title: this.props.translationsStore.translate('carView.note.history.table.columns.createdAt'),
        sorter: true,
        sortOrder: false,
        width: 100,
        render: text => `${moment(text).format(commonStore.longDateFormat.L)} ${moment(text).format(commonStore.longDateFormat.LT)}`
      },
      {
        dataIndex: 'note',
        title: this.props.translationsStore.translate('carView.note.history.table.columns.note'),
        sorter: true,
        sortOrder: false,
        render: text => <span style={{ width: 420, display: 'block', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{text}</span>
      }
    ];
    this.historyFetchMethods = [
      {
        key: 'notes',
        method: 'getNotesHistory',
        defaultSorter: { field: 'createdAt', order: 'DESC' }
      }
    ];

    this.state = {
      textarea: '',
      sending: false,
      lastNoteDate: props.lastNoteDate,

      sorters: { notes: this.historyFetchMethods[0].defaultSorter },
      lighboxVisibile: false,
      lightboxContent: ''
    };
  }

  static getDerivedStateFromProps(props, state) {
    let newState = Object.assign({}, state);
    newState = Object.assign(newState, { lastNoteDate: props.lastNoteDate });
    return newState;
  }

  sendNote = e => {
    this.setState({ sending: true });
    api('sendNote', this.props.carId, this.state.textarea).then(result => {
      this.setState({ textarea: '', sending: false });
      return isFunction(this.props.afterSendNote) && this.props.afterSendNote(result);
    });
  };

  writeMessage = e => {
    this.setState({ textarea: e.target.value });
  };

  loadHistory = (methods = ['notes'], page = 1) => {
    this.setState({
      historyLoading: true
    });
    const { carId } = this.props;
    const { sorters } = this.state;
    Promise.all(
      methods.map(method => {
        const { field: sort, order } = sorters[method];
        return api(this.historyFetchMethods.find(helper => helper.key === method).method, carId, page, sort, order);
      })
    ).then(methodsResponse => {
      const historySum = !!this.state.historySum
        ? this.state.historySum
        : methods.reduce((accumulator, method, index) => {
            return accumulator + methodsResponse[index].count;
          }, 0);
      let computedResources = methodsResponse.map((response, index) => ({
        key: methods[index],
        count: response.count,
        page,
        dataSource: response.rows.map((row, index) => ({
          ...row,
          key: index
        })),
        pagination: { total: response.count, current: page }
      }));
      let definedResources = this.state.historyResources;
      if (definedResources) {
        definedResources = definedResources.map(item => {
          const resource = computedResources.find(resource => resource.key === item.key);
          return resource ? resource : item;
        });
      } else {
        definedResources = computedResources;
      }

      const historyActiveKey = definedResources.reduce((accumulator, currentValue) => {
        return accumulator === null && methods.findIndex(method => method === currentValue.key) > -1 && currentValue.count > 0 ? currentValue.key : accumulator;
      }, null);

      let historyData = {
        historyLoading: false,
        historySum: historySum,
        historyResources: definedResources,
        historyActiveKey
      };

      if (historySum !== 0) {
        historyData = { ...historyData, historyShow: true, historyNoDataHint: false };
      } else {
        historyData = { ...historyData, historyShow: false, historyNoDataHint: true };
      }
      this.setState(historyData);
    });
  };

  switchHistory = e => {
    this.loadHistory([e.target.value]);
  };

  handleTableChange = (key, pagination, filters, sorter) => {
    const { current: page } = pagination;
    const sorterVal = pick(sorter, ['field', 'order']);
    sorterVal.order = sorterVal.order === 'descend' ? 'DESC' : 'ASC';
    this.setState({ sorters: { ...this.state.sorters, [key]: sorterVal } }, () => {
      this.loadHistory([key], page);
    });
  };

  render() {
    const { translationsStore, commonStore, style } = this.props;
    const { sorters, historyActiveKey } = this.state;

    const historySwitch = this.historyFetchMethods.filter(item => ((this.state.historyResources || []).find(helper => helper.key === item.key) || {}).count > 0);
    const columns = this.historyTableColumns.map(column => {
      let sortOrder = (sorters[historyActiveKey] || {}).field === column.dataIndex ? sorters[historyActiveKey].order : false;
      sortOrder = sortOrder === 'DESC' ? 'descend' : sortOrder === 'ASC' ? 'ascend' : false;
      return {
        ...column,
        sortOrder
      };
    });

    return (
      <Card className="NoteCard" style={style} id="NoteCard">
        <div className="header">
          <div>{translationsStore.translate('carView.note.title')}</div>
          <div style={{ display: 'flex' }}>
            {this.state.lastNoteDate && (
              <Col className="lastNoteDate">
                <span>{translationsStore.translate('carView.note.lastNoteDate')}: </span>
                <span>{distanceInWordsToNow(this.state.lastNoteDate, { addSuffix: true, locale: commonStore.dateFnsLocale })}</span>
              </Col>
            )}
            <Popover
              content={translationsStore.translate('carView.note.historyNoData.message')}
              title={translationsStore.translate('carView.note.historyNoData.title')}
              trigger="click"
              visible={this.state.historySum === 0 && this.state.historyNoDataHint}
              onVisibleChange={visible => this.setState({ historyNoDataHint: visible })}
            >
              <Button onClick={() => this.loadHistory()} type="primary">
                {translationsStore.translate('carView.history')}
              </Button>
            </Popover>
          </div>
        </div>
        <Skeleton loading={this.props.loading}>
          <Row className="body">
            <Col>
              <TextArea
                onChange={this.writeMessage}
                value={this.state.textarea}
                placeholder={translationsStore.translate('carView.note.insertTextHere')}
                autosize={{ minRows: 3, maxRows: 3 }}
                resize="false"
              />
            </Col>
          </Row>
          <Row className="footer" type="flex">
            <Col>
              <Button type="primary" disabled={!this.state.textarea || this.state.textarea.length === 0} onClick={this.sendNote}>
                {translationsStore.translate('common.send')}
              </Button>
            </Col>
          </Row>
        </Skeleton>
        <Modal
          title={translationsStore.translate('carView.note.history.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.historyShow}
          getContainer={() => document.getElementById('NoteCard')}
          footer={null}
          onCancel={() => this.setState({ historyShow: false })}
          centered={true}
        >
          <Spin spinning={this.state.historyLoading}>
            <div style={{ marginBottom: 20 }}>
              {historySwitch.length > 1 && (
                <RadioGroup onChange={this.switchHistory} defaultValue={historySwitch[0].key}>
                  {historySwitch.map((item, index) => (
                    <RadioButton key={index} value={item.key}>
                      {translationsStore.translate(`carView.note.history.panels.${item.key}`)}
                    </RadioButton>
                  ))}
                </RadioGroup>
              )}
            </div>
            {(this.state.historyResources || []).map(
              (item, index) =>
                item.count > 0 &&
                item.key === this.state.historyActiveKey && (
                  <Table
                    key={index}
                    dataSource={this.state.historyResources[index] && this.state.historyResources[index].dataSource}
                    columns={columns}
                    pagination={item.pagination}
                    onChange={(...params) => this.handleTableChange(item.key, ...params)}
                    rowClassName="historyRow"
                    onRow={(record, rowIndex) => ({
                      onClick: event => {
                        this.setState({ lighboxVisibile: true, lighboxTitle: moment(record.createdAt).format(commonStore.longDateFormat.LLL), lighboxContent: record.note });
                      }
                    })}
                  />
                )
            )}
          </Spin>
        </Modal>
        <Modal title={this.state.lighboxTitle} visible={this.state.lighboxVisibile} footer={null} onCancel={() => this.setState({ lighboxVisibile: false })}>
          {this.state.lighboxContent}
        </Modal>
      </Card>
    );
  }
}
